import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import Routes from "./Routes";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <Routes />
        </SubscriptionProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;

